interface PressItem {
    title: string,
    date: string,
    provider: string,
    source: string
}

export const Press: PressItem[] = [
    {
        title: "Aberto o prazo de inscrición para a IX edición da carreira nocturna SantYaGo 10K o vindeiro 10 de maio",
        date: '2025-02-19',
        provider: 'concello',
        source: 'https://santiagodecompostela.gal/gl/noticias/aberto-o-prazo-de-inscricion-para-ix-edicion-da-carreira-nocturna-santyago-10k-o-vindeiro',
    },
    {
        title: "A IX edición da carreira nocturna SantYaGo 10K arranca o vindeiro sábado 10 de maio con todas as prazas cubertas",
        date: '2025-05-07',
        provider: 'concello',
        source: 'https://santiagodecompostela.gal/gl/noticias/ix-edicion-da-carreira-nocturna-santyago-10k-arranca-o-vindeiro-sabado-10-de-maio-con',
    },
    {
        title: "La Carreira Nocturna Santyago 10K ya solo dispone de cien plazas para cerrar el cupo",
        date: '2025-04-26',
        provider: 'lvdg',
        source: 'https://www.lavozdegalicia.es/noticia/santiago/2025/04/26/carreira-nocturna-santyago-10k-solo-dispone-cien-plazas-cerrar-cupo/00031745691162041726837.htm',
    },
    {
        title: "La carrera nocturna SantYaGo estrena un recorrido de 4 kilómetros para escolares",
        date: '2025-02-19',
        provider: 'ecg',
        source: 'https://www.elcorreogallego.es/deportes/2025/02/19/carrera-nocturna-santyago-estrena-recorrido-escolares-114468220.html',
    },
    {
        title: "Santiago celebra este sábado su popular carrera nocturna con una gran novedad: recorrido, horarios e inscripción",
        date: '2025-05-07',
        provider: 'ecg',
        source: 'https://www.elcorreogallego.es/santiago/2025/05/07/santiago-celebra-sabado-popular-carrera-117059151.html',
    },
    {
        title: '"La SantYaGo está orientada a un corredor muy popular y a pasar una noche distinta en Santiago"',
        date: '2025-05-08',
        provider: 'ecg',
        source: 'https://www.elcorreogallego.es/deportes/2025/05/08/santyago-orientada-corredor-popular-pasar-noche-diferente-santiago-117156635.html',
    },
    {
        title: 'A IX carreira nocturna SantYaGo 10K chega este sábado a Santiago con todas as prazas cubertas',
        date: '2025-05-07',
        provider: 'rls',
        source: 'https://radiolidersantiago.com/a-ix-carreira-nocturna-santyago-10k-chega-este-sabado-a-santiago-con-todas-as-prazas-cubertas/',
    },
    {
        title: '9ª CARRERA NOCTURNA SANTYAGO10K en El Corte Inglés Santiago de Compostela',
        date: '2025-03-01',
        provider: 'eci',
        source: 'https://www.elcorteingles.es/centroscomerciales/es/eci/centros/centro-comercial-compostela/eventos/9a-carrera-nocturna-santyago10k',
    },
    {
        title: "La carrera nocturna SantYaGo 10K regresa este sábado: recorrido, horarios y novedades",
        date: '2025-05-08',
        provider: 'elespanol',
        source: 'https://www.elespanol.com/quincemil/deporte/tu-deporte/20250508/carrera-nocturna-santyago-regresa-sabado-recorrido-horarios-novedades/1003743746545_0.html',
    },
    {
        title: "IX Carreira Nocturna SANTYAGO10K",
        date: '2025-04-25',
        provider: 'dds',
        source: 'https://www.diariodesantiago.es/deportes/ix-carreira-nocturna-santyago10k/',
    },
    {
        title: "La carrera popular más importante de Santiago volverá a llenar sus calles este sábado",
        date: '2025-05-09',
        provider: 'dc',
        source: 'https://diariocompostela.elidealgallego.com/articulo/compostela/carrera-popular-importante-santiago-volvera-llenar-calles-sabado-5281031',
    },
    {
        title: "La SantYago 10K encara su décima edición con 1.500 inscritos, el máximo disponible",
        date: '2025-05-10',
        provider: 'lvdg',
        source: 'https://www.lavozdegalicia.es/noticia/santiago/2025/05/09/santyago-10k-encara-decima-edicion-1500-inscritos-maximo-disponible/00031746814034476964980.htm',
    },
    {
        title: "Finaliza la popular carrera solidaria por el autismo SantYaGo 10K",
        date: '2025-05-11',
        provider: 'ecg',
        source: 'https://www.elcorreogallego.es/santiago/2025/05/11/finaliza-popular-carrera-solidaria-autismo-117252995.html',
    },
    {
        title: "David de la Fuente vuela en la SantYago 10K y marca el nuevo récord de la carrera nocturna",
        date: '2025-05-11',
        provider: 'lvdg',
        source: 'https://www.lavozdegalicia.es/noticia/santiago/2025/05/10/david-fuentevuela-santyago-10k-marca-nuevo-record-carrera-nocturna/00031746911291057727760.htm',
    },
];
